/**
 * 파일명 : com0110p.tsx
 * 설명 : 결재문서등록
 * 수정내역
 ************************************************
 * Version    수정일자      수정자    수정내용      
 ************************************************
 *     
 */

/************************************************
 * Import 영역  
 ************************************************/
/* React */
import React from "react";
import { Editor } from '@tinymce/tinymce-react';

/* Reducer */
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { Com0110pAction } from '../../../redux/slice/com/com0110p_slice';
import { IApprDocItemState } from '../../../redux/models/com/com0110p_model';

/* AntD */
import { Input, Layout, Row, Col, Space, Button, Descriptions, Radio } from "antd";

/* 업무 */
import parse from 'html-react-parser';
import * as commonProxy from "libs/CommonProxy";
import * as common from "libs/common";

/************************************************
 * 전역변수 선언영억
 ************************************************/

const Com0110p = (props:any) => {
    /************************************************
     * Render 변수 선언 및 셋팅영역
     ************************************************/
    /**
     * 기능 : State / Reducer 선언
     * param : 
     */
     let tmp = 0;
     const editorHeightDiff = 400;
     const dispatch = useAppDispatch();
     const apprDocItem = useAppSelector((state) => state.Com0110p.apprDocItem);
     const [editorHeight, setEditorHeight] = React.useState<number>(window.innerHeight - editorHeightDiff); // 기본 화면 높이에서 400px을 빼기
     const [editorKey, setEditorKey] = React.useState<number>(0);
     const [isEditMode, setIsEditMode] = React.useState(false);


    /* 업무 */
    const editorRef = React.useRef(null);

    /* AntD */
    const { Content } = Layout;

    React.useEffect(() => {
        const handleResize = () => {
            setEditorHeight(window.innerHeight - editorHeightDiff); // 화면 크기 변경 시 에디터 높이 업데이트

            let tmpKey = ++tmp;
            tmp = tmpKey;
            setEditorKey(tmpKey);
         };
      
        window.addEventListener('resize', handleResize);


        if (props && !common.isEmptyString(props.cd)) {
            setIsEditMode(false);
            // 입력파라미터
            const requestData = {
                cd : props.cd,
                cdGrpId : '014',
                useYn: 'ALL'
            };

            /* 트렌젝션 호출 및 결과 셋팅 */
            commonProxy.callAsyncSvc(requestData, {
                txCd : 'TRCOMR0001',
                success : (responseData:any) => {
                    dispatch(Com0110pAction.setApprDocItem(responseData.codeItems[0]));
                },
            });
        } else {
            setIsEditMode(true);
        }

        return () => {
            window.removeEventListener('resize', handleResize); // cleanup
            dispatch(Com0110pAction.initState());
        };
    }, []);


    /************************************************
     * 이벤트 함수 영역
     ************************************************/
	/**
     * 기능 : 저장버튼 클릭 이벤트
     * 설명 : 등록/수정
     * param : 
     * return : None
     */

    const btnSave_onClick = () => {
        /* 정합성 체크 */
        if (common.isEmptyString(apprDocItem.cd)) {
            const param = {
                title : '위드정보 확인',
                contents: '[결재문서구분코드]는 필수 입력항목 입니다.',
            };

            common.openInfo(param);
            return false;
        }

        if (common.isEmptyString(apprDocItem.cdNm)) {
            const param = {
                title : '위드정보 확인',
                contents: '[결재문서구분명]은 필수 입력항목 입니다.',
            };

            common.openInfo(param);
            return false;
        }

        // 입력파라미터
        const requestData = {
            ...apprDocItem
        };

        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc(requestData, {
            txCd : props.cd ? 'TRCOMS0004' : 'TRCOMS0003',
            success : (responseData:any) => {
                dispatch(Com0110pAction.setApprDocItem(responseData.codeItems));
                setIsEditMode(false);

                const param = {
                    title : '위드정보 확인',
                    contents: '정상적으로 처리 되었습니다.',
                };
    
                common.openAlert(param);
            },
        });
    };

	/**
     * 기능 : 화면 닫기
     * 설명 : 화면 닫기
     * param : 
     * return : None
     */
    const btnClose_onClick = () => {
        props.cancel();
    }

	/**
     * 기능 : 초기화
     * 설명 : 입력컴포넌트
     * param : 
     * return : None
     */
    const btnReset_onClick = React.useCallback(() => {
        dispatch(Com0110pAction.initState());
        setIsEditMode(true);
    }, []);

    /**
     * 기능 : onClick 이벤트 선언
     * param : 
     */
    const onClick = async (e:any, record:IApprDocItemState) => {
        const buttonName = e.currentTarget.name;
        switch (buttonName) {
            case "btnReset": {
                btnReset_onClick();
                break;
            }
            case "btnSave": {
                btnSave_onClick();
                break;
            }
            case "btnClose": {
                btnClose_onClick();
                break;
            }
            default:
        }
    };

    /************************************************
     * 개발자함수 영역
     ************************************************/
    const ParsedComponent = () => {
        const htmlString = apprDocItem.rmk1;
      
        // HTML 엔티티로 변환
        const escapedHtml = htmlString
          .replace(/\{/g, '&#123;')
          .replace(/\}/g, '&#125;');
      
        return <div dangerouslySetInnerHTML={{ __html: escapedHtml }} />;
    };

    return (
        /* 화면 디자인 영역*/
        <Layout>
            <Content>
                <Descriptions bordered column={2} size="small">
                    <Descriptions.Item label="* 결재문서구분코드">
                        <Input id="inputCd" value={apprDocItem.cd} disabled={!isEditMode} placeholder="002 부터 1씩 증가시키며 입력하세요" onChange={(e:any) => {
                            dispatch(Com0110pAction.setApprDocItem({ ...apprDocItem, cd : e.currentTarget.value }));
                        }}/>
                    </Descriptions.Item>
                    <Descriptions.Item label="* 결재문서구분명">
                        <Input id="inputCdNm" value={apprDocItem.cdNm} disabled={!isEditMode} onChange={(e:any) => {
                            dispatch(Com0110pAction.setApprDocItem({ ...apprDocItem, cdNm : e.currentTarget.value }));
                        }}/>
                    </Descriptions.Item>
                    <Descriptions.Item label="* 사용여부">
                        <Radio.Group value={apprDocItem.useYn} disabled={!isEditMode} onChange={(e:any) => {
                            dispatch(Com0110pAction.setApprDocItem({ ...apprDocItem, useYn : e.target.value }));
                        }}>
                            <Radio key="useYn_Y" value="Y">사용</Radio>
                            <Radio key="useYn_N" value="N">미사용</Radio>
                        </Radio.Group>  
                    </Descriptions.Item>
                    <Descriptions.Item label="* 증명서여부">
                        <Radio.Group value={apprDocItem.attr1} disabled={!isEditMode} onChange={(e:any) => {
                            dispatch(Com0110pAction.setApprDocItem({ ...apprDocItem, attr1 : e.target.value }));
                        }}>
                            <Radio key="certYn_N" value="N">일반문서</Radio>
                            <Radio key="certYn_Y" value="Y">증명서</Radio>
                        </Radio.Group>  
                    </Descriptions.Item>
                </Descriptions>

                <Row style={{marginTop: 10 }}>
                    <Col style={{width:'100%'}}>
                        {!isEditMode ?
                        <div key={editorKey} style={{ height: editorHeight, display: 'flex', flexDirection: 'column', width : '100%', flex: '1 1 auto', overflowY: 'auto' }}>{ParsedComponent()}</div> :
                        <Editor
                            key={editorKey}
                            id='editorBoard'
                            apiKey={common.editorKey}
                            onInit={(_, editor) => {
                                editorRef.current = editor;
                                document.getElementsByClassName('tox-statusbar')[0].remove();
                            }}
                            value={apprDocItem.rmk1}
                            init={{
                                resize:false,
                                toolbar_mode: 'sliding',
                                language:'ko_KR',
                                height: editorHeight,
                                menubar: false,
                                plugins: [
                                    'advlist','autolink',
                                    'lists','link','image','charmap','preview','anchor','searchreplace','visualblocks',
                                    'fullscreen','insertdatetime','table'
                                    ],
                                toolbar: 'undo redo | fontfamily fontsize | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist checklist outdent indent | removeformat | table',
                                content_style: 'body { font-family:굴림; font-size:12pt }',
                                font_formats:'본고딕=Noto sans KR;돋움=Dotum;돋움체=DotumChe;굴림=Gulim;굴림체=GulimChe;바탕=Batang;바탕체=BatangChe;궁서=Gungsuh;궁서체=GungsuhChe;새굴림=New Gulim;맑은 고딕=Malgun Gothic;나눔 고딕=Nanum Gothic;나눔 명조=Nanum Myoungjo'
                            }}
                            onEditorChange={() => {
                                dispatch(Com0110pAction.setApprDocItem({...apprDocItem, rmk1: editorRef.current.getContent()}));
                            }}
                        />
                        }
                    </Col>
                </Row>
                <Row justify='center'>
                    <Col>
                        <Space direction="vertical">
                            <Row justify="space-around" style={{ marginTop: 20 }}>
                                <Space size="small">
                                    <Button
                                        name="btnReset"
                                        className="background-color-default-button"
                                        disabled={!common.isAdmin()}
                                        onClick={(e:any) => onClick(e, null)}
                                        >
                                        초기화
                                    </Button>
                                    {!isEditMode ?
                                    <Button
                                        name="btnEdit"
                                        className="background-color-default-button"
                                        disabled={!common.isAdmin()}
                                        onClick={() => {
                                            setIsEditMode(true);
                                        }}
                                    >
                                        수정
                                    </Button>
                                    : null}
                                    {isEditMode ?
                                    <Button
                                        name="btnSave"
                                        className="background-color-primary-button"
                                        disabled={!common.isAdmin()}
                                        onClick={(e:any) => onClick(e, null)}
                                    >
                                        저장
                                    </Button>
                                    : null}
                                    <Button
                                        name="btnClose"
                                        className="background-color-default-button"
                                        onClick={(e:any) => onClick(e, null)}
                                    >
                                        닫기
                                    </Button>
                                </Space>
                            </Row>
                        </Space>
                    </Col>
                </Row>
            </Content>
        </Layout>
    );
}

export default Com0110p;